export const ProductSource = {
  Navision: 1,
  Delta: 2,
  Xledger: 3,
  BCVoninRefa: 4,
  BCFaroeIslands: 5,
} as const;
export type ProductSource = (typeof ProductSource)[keyof typeof ProductSource];
